// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2NWK-","title":"Header_title__1388a","left":"Header_left__10obk","clinicName":"Header_clinicName__1ObuI"};